define([
    'lodash'
], function (
    _
) {
    'use strict';

    function Model() {
        // We need to check for Proxy support since this code might run in IE11...
        // In IE, just return the original object, model changes will not automatically trigger callbacks.
        const observe = typeof Proxy !== 'undefined' ? (obj, handler) => new Proxy(obj, handler) : obj => obj;

        const callbacksObserveHandler = {
            set(target, key, value) {
                if (key === 'updateOnNextTick' && value && value !== target[key]) {
                    if (typeof requestAnimationFrame !== 'undefined') {
                        // eslint-disable-next-line no-undef
                        requestAnimationFrame(triggerImmediateUpdate);
                    } else {
                        setTimeout(triggerImmediateUpdate, 20);
                    }
                }
                // eslint-disable-next-line santa/no-side-effects
                target[key] = value;
                return true;
            }
        };
        const modelObserveHandler = {
            set(target, key, value) {
                if (typeof value === 'object' && value !== null) {
                    // eslint-disable-next-line santa/no-side-effects
                    target[key] = observe(value, modelObserveHandler);
                } else {
                    // eslint-disable-next-line santa/no-side-effects
                    target[key] = value;
                }
                triggerUpdate();
                return true;
            },
            deleteProperty(target, key) {
                if (key in target) {
                    delete target[key];
                    triggerUpdate();
                    return true;
                }
                return false;
            }
        };

        const callbacks = observe({
            onUpdate: _.noop,
            updateOnNextTick: false
        }, callbacksObserveHandler);

        const model = observe({
            timelines: observe({}, modelObserveHandler),
            timelineQueues: observe({}, modelObserveHandler),
            isMobileView: false,
            pageId: null
        }, modelObserveHandler);

        function triggerUpdate() {
            callbacks.updateOnNextTick = true;
        }

        function triggerImmediateUpdate() {
            callbacks.onUpdate();
            callbacks.updateOnNextTick = false;
        }

        // const delayedSet = (...args) => Promise.resolve().then(_.set.apply(_, args));
        // const delayedDelete = (obj, item) => Promise.resolve().then(() => {delete obj[item];});
        // const delayedPush = (arr, item) => Promise.resolve().then(() => {arr.push(item);});

        // addActionToTimelineQueue: push('timelineQueues', arg0, 'items'), // {id: {items: {[{id, action, data, resolve, reject}, ...]}}
        // setTimelineQueue: setter('timelineQueues', arg0), // remove queue
        // setCreateTimelineActionToQueue: setter('timelineQueues', arg0, 'createItem'), // remove queue

        // addTimelineCompId: push('timelines', arg0, 'compIds'), // {id: {sequence, compIds: [...]}}
        // setTimelineCompIds: setter('timelines', arg0, 'compIds'), // {id: {sequence, compIds: [...]}}
        // setTimelineSequence: setter('timelines', arg0, 'sequence'), // {id: {sequence, compIds: [...]}}
        // setTimeline: setter('timelines', arg0) // remove timeline

        return {
            getTimelines() {
                return _.clone(model.timelines);
            },
            getQueues() {
                return _.clone(model.timelineQueues);
            },
            triggerUpdate,
            triggerImmediateUpdate,
            setIsMobileView(isMobile) {
                model.isMobileView = isMobile;
            },
            getIsMobileView() {
                return model.isMobileView;
            },
            setPageId(id) {
                model.pageId = id;
            },
            getPageId() {
                return model.pageId;
            },
            setUpdateCallback(cb) {
                callbacks.onUpdate = cb;
            },
            addActionToTimelineQueue(id, item) {
                const items = _.get(model.timelineQueues, [id, 'items']);
                if (!items) {
                    _.set(model.timelineQueues, [id, 'items'], [item]);
                } else {
                    items.push(item);
                }
            },
            setTimelineQueue(id, data) {
                if (data) {
                    _.set(model.timelineQueues, [id], data);
                } else {
                    delete model.timelineQueues[id];
                }
            },
            setCreateTimelineActionToQueue(id, createItem) {
                if (createItem) {
                    _.set(model.timelineQueues, [id, 'createItem'], createItem);
                } else {
                    delete model.timelineQueues[id].createItem;
                }
            },
            setTimeline(id, data) {
                if (data) {
                    _.set(model.timelines, [id], data);
                } else {
                    delete model.timelines[id];
                }
            },
            setTimelineSequence(id, sequence) {
                _.set(model.timelines, [id, 'sequence'], sequence);
            },
            getTimelineSequence(id) {
                return _.get(model.timelines, [id, 'sequence']);
            },
            addTimelineCompId(id, compId) {
                const compIds = _.get(model.timelines, [id, 'compIds']);
                if (!compIds) {
                    _.set(model.timelines, [id, 'compIds'], [compId]);
                } else if (!_.includes(compIds, compId)) {
                    compIds.push(compId);
                }
            },
            setTimelineCompIds(id, compIds) {
                _.set(model.timelines, [id, 'compIds'], compIds);
            }
        };
    }

    return Model;
});
